module.exports = __webpack_public_path__ + "static/media/functionalTraining.12a70f57.svg";